import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";
import { useLang } from "@/context/LangContext";

const IG = "barbarauwadiee";
const EMAIL = "hello@unfilteredbybarbarauwadie.com";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="border-t border-[rgba(61,50,56,0.08)] bg-[#FBF5F1]" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-16 py-10 flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex flex-col items-center sm:items-start gap-1">
          <span className="font-serif text-xl tracking-[0.18em]">UNFILTERED</span>
          <span className="text-xs text-[#9C8F94]">© {new Date().getFullYear()} Barbara Uwadie. All rights reserved.</span>
        </div>

        <div className="flex items-center gap-6 text-xs uppercase tracking-[0.15em] text-[#9C8F94]">
          <Link to="/contact" className="hover:text-[#C6899E] transition-colors">Privacy</Link>
          <Link to="/contact" className="hover:text-[#C6899E] transition-colors">Terms</Link>
          <a href={`mailto:${EMAIL}`} className="hover:text-[#C6899E] transition-colors" data-testid="footer-email">Email</a>
          <a href={`https://instagram.com/${IG}`} target="_blank" rel="noreferrer"
            className="hover:text-[#C6899E] transition-colors" data-testid="footer-instagram">
            <Instagram className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
}
